<template>
  <v-dialog v-model="dialog" max-width="708">
    <template v-slot:activator="{ on }">
      <base-button
        :text="preorder ? 'Pre-Order' : (authenticatedUser && browsingAs && browsingAs.isBakerFirst ? 'Add to Cart to See Price' : 'Add To Cart')"
        class="add-to-cart-btn ml-sm-4"
        :disabled="disabled"
        :loading="loading"
        :background-color="preorder ? 'orange' : 'dark-blue'"
        @click="addToCart"
      />
    </template>
    <v-card class="add-to-cart-dialog-card-wrapper">
<v-icon class="close-button" @click="close()">
        mdi-close
      </v-icon>

      <div class="overflow-auto">
        <v-card-title class="bpg-card-title">
          <v-icon color="secondary">
            mdi-checkbox-marked-circle
          </v-icon> Added to your cart
        </v-card-title>
                    <div v-for="(item, i) in displayItems" :key="i">
           <date-bought-notification :product-id="item.product.id" />
      </div>
        <div class="add-to-cart-dialog-body">
          <div
            v-for="(item, i) of displayItems"
            :key="'cartItem_'+i"
            class="cart-item"
            :class="{'last': i === displayItems.length - 1}"
          >
            <cart-list-item :item="item" add-to-cart-dialog :is-quantity-editable="false" :is-removable="false" />
          </div>
        </div>
        <v-card-actions class="px-0 d-flex flex-column flex-sm-row align-stretch">
          <div class="fx-1 mb-3 mb-sm-0 mr-sm-4">
            <base-button
              block
              text="Continue Shopping"
              background-color="outline-dark-blue"
              @click="close"
            />
          </div>
          <div class="fx-1">
            <base-button
              block
              text="View Cart"
              @click="$router.push('/cart')"
            />
          </div>
        </v-card-actions>
        <div>
           <div v-if="adImageUrl && adImageUrl.length > 0">
              <a :href="adClickUrl" class="text-no-underline clickable">
              <base-image
                  :source="adImageUrl | fullImagePath('S')"
                  :alt="'Baker Book House Banner Image'"
                />
                </a>
              </div>
        </div>
        <div v-if="!hideRelated" class="related-products-wrapper">
          <book-cover-reel
            :reel-title="cartItems.length > 1 ? 'Related To These Products' : 'Related To This Product'"
            :reel-items="recommendedProducts.slice(0, 3)"
            :page-size="3"
            :loading="recommendedProductsLoading"
          />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import DateBoughtNotification from '@/components/snippets/date-bought-notification'
import { ORGANIZATIONS_TYPES } from '@/store/organizations'
import { CART_TYPES } from '@/store/cart'
import BookCoverReel from '@/components/content-sections/book-cover-reel'
import CartListItem from '@/components/snippets/cart-list-item'

export default {
  name: 'AddToCartDialog',
  components: {
    CartListItem,
    BookCoverReel,
    DateBoughtNotification
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    cartItems: {
      type: Array,
      required: true
    },
    preorder: {
      type: Boolean,
      default: false
    },
    addMultipleItems: {
      type: Boolean,
      default: false
    },
    hideRelated: {
      type: Boolean,
      default: false
    },
    adImageUrl: {
      type: String,
      default: null
    },
    adClickUrl: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...mapState('cart', [
      'items',
      'recommendedProducts',
      'recommendedProductsLoading',
      'promotionApplication'
    ]),
    ...mapState({
      authenticatedUser: state => state.auth.authenticatedUser
    }),
    ...mapGetters({
      browsingAs: ORGANIZATIONS_TYPES.getters.browsingAs
    }),
    displayItems () {
      // return only the items that are in cartItems
      // items has item information (along with promotion info)
      const result = this.items.filter(x => this.hasCartItem(x.product.id))
      return result
    },
    getProductIds () {
      const s = this.items.map(x => x.product.id)
      console.log(s)
      return s
    }

  },
  methods: {
    ...mapActions({
      addItemToCart: CART_TYPES.actions.addItemToCart,
      addItemsToCart: CART_TYPES.actions.addItemsToCart
    }),
    clicked () {
      this.$emit('clicked')
    },
    close () {
      this.dialog = false
      this.$emit('closed')
    },
    addToCart () {
      this.loading = true
      if (this.addMultipleItems) {
        this.addItemsToCart(this.cartItems)
          .then((items) => {
            if (items) {
              this.dialog = true
            }
          })
          .finally(() => (this.loading = false))
      } else {
        this.addItemToCart(this.cartItems[0])
          .then((item) => {
            if (item) {
              this.cartItems[0] = item
              this.dialog = true
            }
          })
          .finally(() => (this.loading = false))
      }
    },
    hasCartItem (productId) {
      return !!this.cartItems.find(x => x.product.id === productId)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './scss/variables';

  .add-to-cart-btn {
    flex: 2;
  }

  .close-button {
    position: absolute;
    top: 7px;
    right: 7px;
  }

  .cart-item {
    border-top: 1px solid $light-grey;

    &.last {
      border-bottom: 1px solid $light-grey;
    }
  }

  .add-to-cart-dialog-card-wrapper {
    font-size: 10px;
    padding-top: 3.5em;

    .overflow-auto {
      max-height: 80vh;
      padding: 0 3.2em 3.2em 3.2em;
    }

    .add-to-cart-dialog-body {
      margin: 3.2em 0;

      .discount-item {
        font-size: 1.6em;
        display: flex;
        justify-content: space-between;
        font-weight: $font-weight-extra;
        margin: 1.5em 0;

        .discount-sub-text-wrapper {
          display: flex;
          flex-direction: column;
          flex: 1;
        }
      }
    }

    .related-products-wrapper {
      .scale-with-screen {
        font-size: 0.55vw;
      }
    }
  }

  @media screen and (max-width: $breakpoint-xs) {
    .bpg-card-title {
      font-size: 1.8em !important;
      font-weight: 500;
      i {
        margin-right: 8px !important;
        font-size: 20px;
      }
    }
  }
</style>
